import { callSmartAPI, BYApiCall, TILE_API_KEY_HEADER, X_SESSION_KEY_HEADER } from '../../../Utils/Api/Api';

// Use environment-configured Smart API base to respect current env (dev/test/prod)
const SMART_CHAT_BASE = `${process.env.SMART_APP_BASE_API_URL}`;

// Add Tile (User-Tile)
// NOTE: We now support passing a per-assistant SmartApps AppKey (e.g., `sa_tenant_key`).
// When provided, this overrides the env-level SMART_APP_APPKEY so tiles are scoped
// to the currently selected assistant.
export const addTile = async (body, appKey) => {
  const url = `${SMART_CHAT_BASE}/smart-chat/user-tile`;
  const response = await callSmartAPI(url, 'POST', body, {}, 'web', appKey);
  return {
    payload: response?.Payload,
    isSuccess: response?.IsSuccess ?? response?.isSuccess,
    message: response?.StatusDesc || response?.message,
    statusCode: response?.StatusCode ?? response?.statusCode,
  };
};

// Delete Tile (User-Tile)
// Optional appKey allows deleting within a specific assistant's SmartApps context.
export const deleteTile = async (tileId, appKey) => {
  const url = `${SMART_CHAT_BASE}/smart-chat/user-tile/${tileId}`;
  const response = await callSmartAPI(url, 'DELETE', null, {}, 'web', appKey);
  return {
    payload: response?.Payload,
    isSuccess: response?.IsSuccess ?? response?.isSuccess,
    message: response?.StatusDesc || response?.message,
    statusCode: response?.StatusCode ?? response?.statusCode,
  };
};

// Edit Tile (User-Tile)
// Optional appKey allows editing within a specific assistant's SmartApps context.
export const editTile = async (tileId, body, appKey) => {
  const url = `${SMART_CHAT_BASE}/smart-chat/user-tile/${tileId}`;
  const response = await callSmartAPI(url, 'PUT', body, {}, 'web', appKey);
  return {
    payload: response?.Payload,
    isSuccess: response?.IsSuccess ?? response?.isSuccess,
    message: response?.StatusDesc || response?.message,
    statusCode: response?.StatusCode ?? response?.statusCode,
  };
};

// Get Dashboard Data (User-Dashboard)
// Optional appKey allows fetching dashboard structure for a specific assistant's AppKey.
export const getDashboard = async (dashboardId = null, appKey) => {
  const url = `${SMART_CHAT_BASE}/smart-chat/user-dashboard${dashboardId ? `?id=${dashboardId}` : ''}`;
  const response = await callSmartAPI(url, 'GET', null, {}, 'web', appKey);
  return {
    payload: response?.Payload,
    isSuccess: response?.IsSuccess ?? response?.isSuccess,
    message: response?.StatusDesc || response?.message,
    statusCode: response?.StatusCode ?? response?.statusCode,
  };
};

// Adjust Tiles (User-Dashboard)
// Optional appKey allows adjusting layout for a specific assistant's dashboard.
export const adjustDashboard = async (dashboardId, tiles, appKey) => {
  const url = `${SMART_CHAT_BASE}/smart-chat/user-dashboard/adjust/${dashboardId}`;
  const body = { Tiles: tiles };
  const response = await callSmartAPI(url, 'PUT', body, {}, 'web', appKey);
  return {
    payload: response?.Payload,
    isSuccess: response?.IsSuccess ?? response?.isSuccess,
    message: response?.StatusDesc || response?.message,
    statusCode: response?.StatusCode ?? response?.statusCode,
  };
};

// Get Tile By Id (User-Tile)
// Optional appKey allows resolving tile details for a specific assistant's context.
export const getTileById = async (tileId, appKey) => {
  const url = `${SMART_CHAT_BASE}/smart-chat/user-tile/${tileId}`;
  const response = await callSmartAPI(url, 'GET', null, {}, 'web', appKey);
  return {
    payload: response?.Payload,
    isSuccess: response?.IsSuccess ?? response?.isSuccess,
    message: response?.StatusDesc || response?.message,
    statusCode: response?.StatusCode ?? response?.statusCode,
  };
};

// Fetch tile live content (fresh data)
export const fetchTileContent = async (tileId, { apiKey, sessionKey } = {}) => {
  try {
    const headers = {
      // As per latest requirement: use the tile ApiKey value for X-Session-Key
      [X_SESSION_KEY_HEADER]: apiKey || sessionKey || '',
    };
    // Use BYApiCall against WMS base URL; do NOT send X-Application-Id for WMS calls
    const response = await BYApiCall(`/warehouse/tile/${tileId}`, 'GET', null, null, headers);
    return response;
  } catch (e) {
    return null;
  }
};
